export default "__VITE_ASSET__79b014e3__"